import {useState, useRef, useEffect, useCallback, useContext} from 'react';
import axios from 'axios';
import Qs from 'qs';
import _ from 'lodash';

import Context from 'utils/Context';
import Conf from 'utils/Conf';

const useChat = eventId => {
  const [messages, setMessages] = useState([]);
  const {appState} = useContext(Context);

  const lastUpdateTimestamp = useRef(0);
  const lastUpdateIndex = useRef(-1);

  const sendMessage = mess => {
    const message = {
      ...mess,
      from: mess.from || appState?.user?.pseudo || null,
    };

    axios
      .post(
        `${Conf.apiBaseUriLegacy}/event/${eventId}/message/`,
        Qs.stringify({
          _method: 'POST',
          ...message,
        }),
        {withCredentials: true},
      )
      .then(({data}) => {
        if (!data) return;
        setMessages([data, ...messages]);
      });
  };

  const handleMessageSend = message => {
    if (message.msgType === 'emoji') _.throttle(sendMessage, 500)(message);
    else sendMessage(message);
  };

  const fetchMessages = useCallback(() => {
    if (!eventId) return;
    const now = Math.floor(Date.now() / 1000);
    const params = {
      lastTimestamp: lastUpdateTimestamp.current,
      event_id: eventId,
      chat_state: lastUpdateIndex.current,
    };
    axios.post(`${Conf.apiBaseUriLegacy}/public_messages`, Qs.stringify(params), {withCredentials: true}).then(({data}) => {
      const {chat, chat_state} = data; // eslint-disable-line camelcase
      setMessages(messagesState => {
        const updatedMessagesState = [...messagesState];
        chat.forEach(newMessage => {
          const existingMessageIndex = updatedMessagesState.findIndex(m => m.id === newMessage.id);
          if (existingMessageIndex !== -1) {
            updatedMessagesState[existingMessageIndex] = {
              ...newMessage,
              delay: 0,
            };
          } else {
            updatedMessagesState.unshift(newMessage);
          }
        });
      
        return updatedMessagesState;
      });
      lastUpdateIndex.current = chat_state; // eslint-disable-line camelcase
      lastUpdateTimestamp.current = now;
    });
  }, [eventId]);

  useEffect(() => {
    fetchMessages();
    const interval = setInterval(fetchMessages, 5000);

    return () => {
      clearInterval(interval);
    };
  }, [fetchMessages]);

  return {
    messages,
    handleMessageSend,
  };
};

export default useChat;
